const billingColumns = {
  TXN_TYPE: 'TRANSACTIONTYPE',
  DATE: 'DATE',
  POSTING_DATE: 'GLPOSTINGDATE',

  CUSTOMER_ID: 'CUSTOMER_ID',
  DUE_DATE: 'DATEDUE',

  LINE: 'LINE',
  ITEM_ID: 'ITEMID',
  ITEM_DESC: 'ITEMDESC',

  PERIOD_END_DATE: 'PERIOD_END_DATE',

  QUANTITY: 'QUANTITY',
  UNIT: 'UNIT',
  PRICE: 'PRICE',

  LOCATION_ID: 'LOCATIONID',
  VENDOR_ID: 'SODOCUMENTENTRY_VENDORID',
  MEMO: 'MEMO',

  SAGE_ID: 'SAGE_ID',
};

const billing_v1 = [
  billingColumns.TXN_TYPE,
  billingColumns.DATE,
  billingColumns.POSTING_DATE,

  billingColumns.CUSTOMER_ID,
  billingColumns.DUE_DATE,

  billingColumns.LINE,
  billingColumns.ITEM_ID,
  billingColumns.ITEM_DESC,

  billingColumns.PERIOD_END_DATE,

  billingColumns.QUANTITY,
  billingColumns.UNIT,
  billingColumns.PRICE,

  billingColumns.LOCATION_ID,
  billingColumns.VENDOR_ID,

  billingColumns.MEMO,

  billingColumns.SAGE_ID,
];

const rate_types = {
  DT: 'DT',
  REG: 'Regular',
  OT: 'OT',
};

module.exports = {
  billingColumns,
  billing_v1,
  rate_types,
};
